import { render } from "./GymCategoryList.vue?vue&type=template&id=c9c41b06"
import script from "./GymCategoryList.vue?vue&type=script&lang=js"
export * from "./GymCategoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__